import { FONT } from "../../../../theme/theme.ts";

export const tileTextStyle = {
  fontSize: 28,
  fill: "#fff",
  fontFamily: FONT,
  fontWeight: 'bold',
};